// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { Batch, BatchInfo, BranchInfo, FileContentPart, GitCommitChange, GitCommitFileRequest, GitCommitInfo, GitCommitResult, GitFile, GitTextSearchOccurrence, InlineDiff, ListFilesOptions, ProjectKey, SideBySideDiff } from "./TypeDefinitions.ts"

export interface CodeViewService {
  editFiles(projectKey: ProjectKey, repository: string, baseCommit: string, targetBranch: string, commitMessage: string, files: GitCommitFileRequest[]): Promise<GitCommitResult>

  findFiles(projectKey: ProjectKey, repository: string, commit: string | null, pattern: string, batchInfo: BatchInfo): Promise<Batch<GitFile>>

  getBranch(projectKey: ProjectKey, repository: string, head: string): Promise<BranchInfo | null>

  getBranches(batchInfo: BatchInfo, projectKey: ProjectKey, repository: string, query: string): Promise<Batch<BranchInfo>>

  getCommitChanges(batchInfo: BatchInfo, projectKey: ProjectKey, repository: string, commits: string[]): Promise<Batch<GitCommitChange>>

  getFileContentBytes(projectKey: ProjectKey, repository: string, blobId: string, skip: number, limit: number): Promise<FileContentPart>

  getInlineDiff(projectKey: ProjectKey, repository: string, change: GitCommitChange, ignoreWhitespaces: boolean, squashSimpleChanges: boolean, selectedRevision: string[] | null): Promise<InlineDiff>

  getSideBySideDiff(projectKey: ProjectKey, repository: string, change: GitCommitChange, ignoreWhitespaces: boolean, selectedRevision: string[] | null): Promise<SideBySideDiff>

  listCommits(batchInfo: BatchInfo, projectKey: ProjectKey, repository: string, query: string | null): Promise<Batch<GitCommitInfo>>

  listFiles(projectKey: ProjectKey, repository: string, commit: string | null, path: string | null, file: string | null, options: ListFilesOptions[], limit: number | null): Promise<GitFile[]>

  textSearch(batchInfo: BatchInfo, projectKey: ProjectKey, repository: string, commit: string, query: string, files: string[]): Promise<Batch<GitTextSearchOccurrence>>
}

export class CodeViewServiceClient implements CodeViewService {
  constructor(private service: ApiService) {}

  async editFiles(projectKey: ProjectKey, repository: string, baseCommit: string, targetBranch: string, commitMessage: string, files: GitCommitFileRequest[]): Promise<GitCommitResult> {
    return getResult(await this.service.rpc<GitCommitResult, never>("CodeViewService/editFiles", {
      projectKey: projectKey,
      repository: repository,
      baseCommit: baseCommit,
      targetBranch: targetBranch,
      commitMessage: commitMessage,
      files: files,
    }))
  }

  async findFiles(projectKey: ProjectKey, repository: string, commit: string | null, pattern: string, batchInfo: BatchInfo): Promise<Batch<GitFile>> {
    return getResult(await this.service.rpc<Batch<GitFile>, never>("CodeViewService/findFiles", {
      projectKey: projectKey,
      repository: repository,
      commit: commit,
      pattern: pattern,
      batchInfo: batchInfo,
    }))
  }

  async getBranch(projectKey: ProjectKey, repository: string, head: string): Promise<BranchInfo | null> {
    return getResult(await this.service.rpc<BranchInfo | null, never>("CodeViewService/getBranch", {
      projectKey: projectKey,
      repository: repository,
      head: head,
    }))
  }

  async getBranches(batchInfo: BatchInfo, projectKey: ProjectKey, repository: string, query: string): Promise<Batch<BranchInfo>> {
    return getResult(await this.service.rpc<Batch<BranchInfo>, never>("CodeViewService/getBranches", {
      batchInfo: batchInfo,
      projectKey: projectKey,
      repository: repository,
      query: query,
    }))
  }

  async getCommitChanges(batchInfo: BatchInfo, projectKey: ProjectKey, repository: string, commits: string[]): Promise<Batch<GitCommitChange>> {
    return getResult(await this.service.rpc<Batch<GitCommitChange>, never>("CodeViewService/getCommitChanges", {
      batchInfo: batchInfo,
      projectKey: projectKey,
      repository: repository,
      commits: commits,
    }))
  }

  async getFileContentBytes(projectKey: ProjectKey, repository: string, blobId: string, skip: number, limit: number): Promise<FileContentPart> {
    return getResult(await this.service.rpc<FileContentPart, never>("CodeViewService/getFileContentBytes", {
      projectKey: projectKey,
      repository: repository,
      blobId: blobId,
      skip: skip,
      limit: limit,
    }))
  }

  async getInlineDiff(projectKey: ProjectKey, repository: string, change: GitCommitChange, ignoreWhitespaces: boolean, squashSimpleChanges: boolean, selectedRevision: string[] | null): Promise<InlineDiff> {
    return getResult(await this.service.rpc<InlineDiff, never>("CodeViewService/getInlineDiff", {
      projectKey: projectKey,
      repository: repository,
      change: change,
      ignoreWhitespaces: ignoreWhitespaces,
      squashSimpleChanges: squashSimpleChanges,
      selectedRevision: selectedRevision,
    }))
  }

  async getSideBySideDiff(projectKey: ProjectKey, repository: string, change: GitCommitChange, ignoreWhitespaces: boolean, selectedRevision: string[] | null): Promise<SideBySideDiff> {
    return getResult(await this.service.rpc<SideBySideDiff, never>("CodeViewService/getSideBySideDiff", {
      projectKey: projectKey,
      repository: repository,
      change: change,
      ignoreWhitespaces: ignoreWhitespaces,
      selectedRevision: selectedRevision,
    }))
  }

  async listCommits(batchInfo: BatchInfo, projectKey: ProjectKey, repository: string, query: string | null): Promise<Batch<GitCommitInfo>> {
    return getResult(await this.service.rpc<Batch<GitCommitInfo>, never>("CodeViewService/listCommits", {
      batchInfo: batchInfo,
      projectKey: projectKey,
      repository: repository,
      query: query,
    }))
  }

  async listFiles(projectKey: ProjectKey, repository: string, commit: string | null, path: string | null, file: string | null, options: ListFilesOptions[], limit: number | null): Promise<GitFile[]> {
    return getResult(await this.service.rpc<GitFile[], never>("CodeViewService/listFiles", {
      projectKey: projectKey,
      repository: repository,
      commit: commit,
      path: path,
      file: file,
      options: options,
      limit: limit,
    }))
  }

  async textSearch(batchInfo: BatchInfo, projectKey: ProjectKey, repository: string, commit: string, query: string, files: string[]): Promise<Batch<GitTextSearchOccurrence>> {
    return getResult(await this.service.rpc<Batch<GitTextSearchOccurrence>, never>("CodeViewService/textSearch", {
      batchInfo: batchInfo,
      projectKey: projectKey,
      repository: repository,
      commit: commit,
      query: query,
      files: files,
    }))
  }

}

